import { API_URL, LOGIN_REDIRECT_URL } from "../Constants";
import firebaseAuth from "../config/firebase-config";

const MAX_RETRIES = 1;

async function verifySession() {
    try {
        const response = await fetch(`${API_URL}/session/verify`, {
            method: "GET",
            credentials: "include",
        });
        if (!response.ok) return null;
        const data = await response.json();
        if (data.status !== "success") return null;
        return data;
    } catch {
        return null;
    }
}

/**
 * Verifies the cross-subdomain session cookie and signs in to Firebase client SDK.
 * Returns user info on success, or redirects to the marketing site login on failure.
 */
export async function initSessionAuth() {
    let retries = 0;

    while (retries <= MAX_RETRIES) {
        const session = await verifySession();

        if (!session) {
            redirectToLogin();
            return null;
        }

        try {
            await firebaseAuth.signInWithCustomToken(session.customToken);
            return {
                uid: session.uid,
                email: session.email,
                name: session.name,
                picture: session.picture,
            };
        } catch (err) {
            if (retries < MAX_RETRIES) {
                retries++;
                continue;
            }
            console.error("signInWithCustomToken failed after retry:", err);
            redirectToLogin();
            return null;
        }
    }
}

/**
 * Clears the cross-subdomain session cookie, signs out of Firebase,
 * cleans up legacy localStorage items, and redirects to the marketing site login.
 */
export async function sessionLogout() {
    try {
        await fetch(`${API_URL}/session/logout`, {
            method: "POST",
            credentials: "include",
        });
    } catch (err) {
        console.warn("Failed to destroy session cookie:", err);
    }

    await firebaseAuth.signOut();
    localStorage.removeItem("user");
    localStorage.removeItem("styldod-token");
    redirectToLogin();
}

export function redirectToLogin() {
    window.location.href = LOGIN_REDIRECT_URL;
}
